import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
type LegalType = 'privacy' | 'terms';
interface LegalModalProps {
  type: LegalType;
  onClose: () => void;
}
const content: Record<LegalType, {
  title: string;
  body: React.ReactNode;
}> = {
  privacy: {
    title: 'Políticas de Privacidad',
    body: <div className="flex flex-col gap-5" data-id="element-225">
        <p data-id="element-226">
          En <strong data-id="element-227">DULCE LIBERTAD — Método Repostería Zero</strong> nos
          comprometemos a proteger tu privacidad. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-228">
          1. Información que recopilamos
        </h3>
        <p data-id="element-229">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital: nombre, correo electrónico y
          datos de pago (procesados de forma segura por nuestro proveedor de
          pagos).
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-230">
          2. Uso de la información
        </h3>
        <p data-id="element-231">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 flex flex-col gap-1" data-id="element-232">
          <li data-id="element-233">Procesar y confirmar tu compra.</li>
          <li data-id="element-234">Enviarte el acceso al producto digital adquirido.</li>
          <li data-id="element-235">Responderte en caso de soporte o consultas.</li>
          <li data-id="element-236">
            Enviarte comunicaciones relacionadas con el producto (puedes darte
            de baja en cualquier momento).
          </li>
        </ul>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-237">
          3. Compartir información con terceros
        </h3>
        <p data-id="element-238">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, salvo con los proveedores de servicios estrictamente
          necesarios para procesar pagos y entregar el producto (por ejemplo,
          plataformas de pago como Stripe o PayPal).
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-239">
          4. Seguridad
        </h3>
        <p data-id="element-240">
          Implementamos medidas de seguridad razonables para proteger tu
          información. Los datos de pago son procesados mediante conexiones
          cifradas (SSL/TLS) y nunca se almacenan en nuestros servidores.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-241">
          5. Cookies
        </h3>
        <p data-id="element-242">
          Este sitio puede utilizar cookies para mejorar la experiencia de
          navegación y analizar el tráfico de manera anónima. Puedes desactivar
          las cookies en la configuración de tu navegador.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-243">
          6. Tus derechos
        </h3>
        <p data-id="element-244">
          Tienes derecho a acceder, corregir o eliminar tu información personal.
          Para ejercer estos derechos, contáctanos a través de nuestro correo de
          soporte.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-245">
          7. Cambios a esta política
        </h3>
        <p data-id="element-246">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta página con la fecha de
          actualización correspondiente.
        </p>

        <p className="text-sm" style={{
        color: 'var(--text-muted)'
      }} data-id="element-247">
          Última actualización: enero 2026
        </p>
      </div>
  },
  terms: {
    title: 'Términos de Uso',
    body: <div className="flex flex-col gap-5" data-id="element-248">
        <p data-id="element-249">
          Al adquirir <strong data-id="element-250">DULCE LIBERTAD — Método Repostería Zero</strong>,
          aceptas los siguientes términos y condiciones. Por favor, léelos
          detenidamente antes de realizar tu compra.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-251">
          1. Producto digital
        </h3>
        <p data-id="element-252">
          DULCE LIBERTAD es un producto digital (ebook en formato PDF). Una vez
          completado el pago, recibirás acceso inmediato de descarga. No se
          envían productos físicos.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-253">
          2. Licencia de uso
        </h3>
        <p data-id="element-254">
          Al adquirir este producto, obtienes una licencia personal, no
          exclusiva e intransferible para uso propio. Queda estrictamente
          prohibido:
        </p>
        <ul className="list-disc pl-6 flex flex-col gap-1" data-id="element-255">
          <li data-id="element-256">
            Reproducir, distribuir o compartir el contenido total o
            parcialmente.
          </li>
          <li data-id="element-257">Revender o sublicenciar el producto a terceros.</li>
          <li data-id="element-258">
            Publicar el contenido en plataformas públicas o redes sociales.
          </li>
          <li data-id="element-259">
            Utilizar el contenido con fines comerciales sin autorización
            expresa.
          </li>
        </ul>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-260">
          3. Garantía de devolución
        </h3>
        <p data-id="element-261">
          Ofrecemos una garantía de devolución de{' '}
          <strong data-id="element-262">30 días sin preguntas</strong>. Si por cualquier razón no
          estás satisfecho/a con el producto, contáctanos dentro de los 30 días
          posteriores a tu compra y te reembolsaremos el 100% del importe
          pagado.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-263">
          4. Resultados
        </h3>
        <p data-id="element-264">
          Los resultados descritos en este sitio son testimonios reales de
          usuarios. Sin embargo, los resultados individuales pueden variar
          dependiendo de factores como la experiencia previa en repostería, los
          ingredientes disponibles en tu región y el tiempo dedicado a la
          práctica.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-265">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-266">
          Todo el contenido de DULCE LIBERTAD — incluyendo recetas, textos,
          imágenes y metodología — es propiedad intelectual de Carolina Vega y
          está protegido por las leyes de derechos de autor aplicables.
          Cualquier uso no autorizado será perseguido legalmente.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-267">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-268">
          Este producto tiene fines educativos y culinarios. No constituye
          asesoramiento médico o nutricional profesional. Consulta siempre con
          tu médico o nutricionista ante cualquier condición de salud
          específica.
        </p>

        <h3 className="text-lg font-bold" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-269">
          7. Modificaciones
        </h3>
        <p data-id="element-270">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          este sitio.
        </p>

        <p className="text-sm" style={{
        color: 'var(--text-muted)'
      }} data-id="element-271">
          Última actualización: enero 2026
        </p>
      </div>
  }
};
export function LegalModal({
  type,
  onClose
}: LegalModalProps) {
  const {
    title,
    body
  } = content[type];
  // Close on backdrop click
  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };
  // Close on Escape key
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);
  // Prevent body scroll while open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(44, 24, 12, 0.65)',
    backdropFilter: 'blur(4px)'
  }} onClick={handleBackdrop} role="dialog" aria-modal="true" aria-label={title} data-id="element-272">
      <div className="relative w-full max-w-2xl max-h-[85vh] rounded-3xl shadow-2xl flex flex-col overflow-hidden" style={{
      background: 'var(--cream)'
    }} data-id="element-273">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-6 flex-shrink-0" style={{
        background: 'var(--brown)',
        borderBottom: '1px solid rgba(201,168,76,0.3)'
      }} data-id="element-274">
          <h2 className="text-2xl font-bold" style={{
          color: 'var(--gold-light)',
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-275">
            {title}
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full flex items-center justify-center transition-opacity hover:opacity-70" style={{
          background: 'rgba(255,255,255,0.1)'
        }} aria-label="Cerrar" data-id="element-276">
            <XIcon className="w-5 h-5" style={{
            color: 'var(--cream)'
          }} data-id="element-277" />
          </button>
        </div>

        {/* Scrollable body */}
        <div className="overflow-y-auto px-8 py-7 text-base leading-relaxed" style={{
        color: 'var(--brown-light)',
        lineHeight: '1.85'
      }} data-id="element-278">
          {body}
        </div>

        {/* Footer */}
        <div className="flex-shrink-0 px-8 py-5 text-center" style={{
        borderTop: '1px solid var(--cream-dark)'
      }} data-id="element-279">
          <button onClick={onClose} className="px-8 py-3 rounded-full text-sm font-bold tracking-wider uppercase transition-opacity hover:opacity-80" style={{
          background: 'var(--brown)',
          color: 'var(--gold-light)'
        }} data-id="element-280">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}